export default class Global{
	// static httpUrl='http://192.168.1.168:8083/admin/';
	// static httpUrl='http://192.168.0.87:8083/admin/';
	// static httpUrl='https://danche.honghukeji.net:10443/admin/';
	static httpUrl='';
}